<template>
    <div class="faq">

        <v-container fluid>
            <v-row>
                <v-col>
                    <v-img :src="'https://artlesscms.actstudio.xyz/'+about.cover.path" width="100%"></v-img>
                </v-col>
            </v-row>
        </v-container>

        <v-container>
            <v-row>
                <v-col>
                    <div class="faq-container" v-html="about.text">
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>    
</template>

<script>
export default {
    data(){
        return{
            about: {}
        }
    },
    beforeMount: function(){
        fetch('https://www.artlesscms.actstudio.xyz/api/singletons/get/faq?token=a15be93e9cdb43ca2b3778c2077c26')
        .then(data => data.json())
        .then(data => this.about = data);
    },
    mounted: function(){
        var breadcrumbs = [
            {
                text: 'Home',
                link: '/',
                isLink: true
            },
            {
                text: 'FAQ',
                link: '/faq',
                isLink: false
            }
        ];
        this.$emit("updateStatus", breadcrumbs);
        gtag('config', 'UA-26953667-1', {
        'page_title' : 'FAQ',
        'page_path': '/faq'
        });
    }
}
</script>